import {useIsElementDark} from '~/utils/useIsElementDark'

export const TeamPlanIcon = () => {
  const {ref, isDarkMode} = useIsElementDark()

  if (isDarkMode) {
    return (
      <svg
        ref={ref}
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="icons8-team 2">
          <g id="Group">
            <g id="Group_2">
              <path
                id="Vector"
                d="M30.75 18.75C30.75 16.6875 29.0625 15 27 15H21H20.55C18.675 15 17.0625 16.425 16.8375 18.3L15.375 30H19.5V46.5H28.5V30C29.7375 30 30.75 28.9875 30.75 27.75V18.75Z"
                fill="#18181A"
              />
            </g>
            <g id="Group_3">
              <path
                id="Vector_2"
                d="M13.875 17.25H7.875C5.8125 17.25 4.125 18.9375 4.125 21V29.25C4.125 30.6375 5.1 31.8 6.375 32.1375V44.25C6.375 45.4875 7.3875 46.5 8.625 46.5C9.8625 46.5 11.8875 46.5 13.125 46.5C14.3625 46.5 15.375 45.4875 15.375 44.25V32.25H17.625V21C17.625 18.9375 15.9375 17.25 13.875 17.25Z"
                fill="#18181A"
              />
            </g>
            <g id="Group_4">
              <path
                id="Vector_3"
                d="M10.875 13.5C12.9461 13.5 14.625 11.8211 14.625 9.75C14.625 7.67893 12.9461 6 10.875 6C8.80393 6 7.125 7.67893 7.125 9.75C7.125 11.8211 8.80393 13.5 10.875 13.5Z"
                fill="#18181A"
              />
            </g>
            <g id="Group_5">
              <path
                id="Vector_4"
                d="M40.125 17.25H34.125C32.0625 17.25 30.375 18.9375 30.375 21V29.25C30.375 30.6375 31.35 31.8 32.625 32.1375V44.1375C32.625 45.375 33.5625 46.4625 34.8 46.4625C36.075 46.5 38.175 46.5 39.45 46.4625C40.6875 46.425 41.625 45.3375 41.625 44.1375V32.25C42.8625 32.25 43.875 31.2375 43.875 30V21C43.875 18.9375 42.1875 17.25 40.125 17.25Z"
                fill="#18181A"
              />
            </g>
            <g id="Group_6">
              <path
                id="Vector_5"
                d="M37.125 13.5C39.1961 13.5 40.875 11.8211 40.875 9.75C40.875 7.67893 39.1961 6 37.125 6C35.0539 6 33.375 7.67893 33.375 9.75C33.375 11.8211 35.0539 13.5 37.125 13.5Z"
                fill="#18181A"
              />
            </g>
            <g id="Group_7">
              <path
                id="Vector_6"
                d="M6.375 47.625C5.7375 47.625 5.25 47.1375 5.25 46.5V32.925C3.9 32.25 3 30.825 3 29.25V21C3 18.3 5.175 16.125 7.875 16.125H13.875C14.5125 16.125 15 16.6125 15 17.25C15 17.8875 14.5125 18.375 13.875 18.375H7.875C6.4125 18.375 5.25 19.5375 5.25 21V29.25C5.25 30.1125 5.8125 30.8625 6.6375 31.05C7.125 31.1625 7.5 31.6125 7.5 32.1375V46.5C7.5 47.1375 7.0125 47.625 6.375 47.625Z"
                fill="#6610F2"
              />
            </g>
            <g id="Group_8">
              <path
                id="Vector_7"
                d="M10.875 14.625C8.175 14.625 6 12.45 6 9.75C6 7.05 8.175 4.875 10.875 4.875C13.575 4.875 15.75 7.05 15.75 9.75C15.75 12.45 13.575 14.625 10.875 14.625ZM10.875 7.125C9.4125 7.125 8.25 8.2875 8.25 9.75C8.25 11.2125 9.4125 12.375 10.875 12.375C12.3375 12.375 13.5 11.2125 13.5 9.75C13.5 8.2875 12.3375 7.125 10.875 7.125Z"
                fill="#6610F2"
              />
            </g>
            <g id="Group_9">
              <path
                id="Vector_8"
                d="M32.625 47.6242C31.9875 47.6242 31.5 47.1367 31.5 46.4992V35.8867C31.5 35.2492 31.9875 34.7617 32.625 34.7617C33.2625 34.7617 33.75 35.2492 33.75 35.8867V46.4992C33.75 47.1367 33.2625 47.6242 32.625 47.6242Z"
                fill="#6610F2"
              />
            </g>
            <g id="Group_10">
              <path
                id="Vector_9"
                d="M41.625 47.5125C40.9875 47.5125 40.5 47.025 40.5 46.3875V32.25C40.5 31.6125 40.9875 31.125 41.625 31.125C42.2625 31.125 42.75 30.6375 42.75 30V21C42.75 19.5375 41.5875 18.375 40.125 18.375H34.125C33.4875 18.375 33 17.8875 33 17.25C33 16.6125 33.4875 16.125 34.125 16.125H40.125C42.825 16.125 45 18.3 45 21V30C45 31.4625 44.0625 32.7 42.75 33.1875V46.425C42.75 47.025 42.2625 47.5125 41.625 47.5125Z"
                fill="#6610F2"
              />
            </g>
            <g id="Group_11">
              <path
                id="Vector_10"
                d="M37.125 14.625C34.425 14.625 32.25 12.45 32.25 9.75C32.25 7.05 34.425 4.875 37.125 4.875C39.825 4.875 42 7.05 42 9.75C42 12.45 39.825 14.625 37.125 14.625ZM37.125 7.125C35.6625 7.125 34.5 8.2875 34.5 9.75C34.5 11.2125 35.6625 12.375 37.125 12.375C38.5875 12.375 39.75 11.2125 39.75 9.75C39.75 8.2875 38.5875 7.125 37.125 7.125Z"
                fill="#6610F2"
              />
            </g>
            <g id="Group_12">
              <path
                id="Vector_11"
                d="M15.375 40.125C14.7375 40.125 14.25 39.6375 14.25 39V33.75C14.25 33.1125 14.7375 32.625 15.375 32.625C16.0125 32.625 16.5 33.1125 16.5 33.75V39C16.5 39.6375 16.0125 40.125 15.375 40.125Z"
                fill="white"
              />
            </g>
            <g id="Group_13">
              <path
                id="Vector_12"
                d="M24 11.25C26.0711 11.25 27.75 9.57107 27.75 7.5C27.75 5.42893 26.0711 3.75 24 3.75C21.9289 3.75 20.25 5.42893 20.25 7.5C20.25 9.57107 21.9289 11.25 24 11.25Z"
                fill="#18181A"
              />
            </g>
            <g id="Group_14">
              <path
                id="Vector_13"
                d="M24 12.375C21.3 12.375 19.125 10.2 19.125 7.5C19.125 4.8 21.3 2.625 24 2.625C26.7 2.625 28.875 4.8 28.875 7.5C28.875 10.2 26.7 12.375 24 12.375ZM24 4.875C22.5375 4.875 21.375 6.0375 21.375 7.5C21.375 8.9625 22.5375 10.125 24 10.125C25.4625 10.125 26.625 8.9625 26.625 7.5C26.625 6.0375 25.4625 4.875 24 4.875Z"
                fill="white"
              />
            </g>
            <path
              id="Vector_14"
              d="M35.625 45.375H29.625V32.55V32.25V30.9375C30.9375 30.4875 31.875 29.2125 31.875 27.75V21C31.875 19.3125 31.5375 13.875 27 13.875H20.55C18.1125 13.875 16.0125 15.7125 15.7125 18.15L14.25 29.85C14.175 30.45 14.625 31.0125 15.225 31.0875C15.825 31.1625 16.3875 30.7125 16.4625 30.1125L17.925 18.4125C18.075 17.1 19.2 16.125 20.5125 16.125H27C29.2875 16.125 29.625 19.1625 29.625 21V27.75C29.625 28.3875 29.1375 28.875 28.5 28.875C27.8625 28.875 27.375 29.3625 27.375 30V32.25V32.55V45.375H25.125V32.25C25.125 31.6125 24.6375 31.125 24 31.125C23.3625 31.125 22.875 31.6125 22.875 32.25V45.375H20.625V30C20.625 29.3625 20.1375 28.875 19.5 28.875C18.8625 28.875 18.375 29.3625 18.375 30V45.375H12.375C11.7375 45.375 11.25 45.8625 11.25 46.5C11.25 47.1375 11.7375 47.625 12.375 47.625H35.625C36.2625 47.625 36.75 47.1375 36.75 46.5C36.75 45.8625 36.2625 45.375 35.625 45.375Z"
              fill="white"
            />
          </g>
        </g>
      </svg>
    )
  }

  return (
    <svg
      ref={ref}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icons8-team 1">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M30.75 18.75C30.75 16.6875 29.0625 15 27 15H21H20.55C18.675 15 17.0625 16.425 16.8375 18.3L15.375 30H19.5V46.5H28.5V30C29.7375 30 30.75 28.9875 30.75 27.75V18.75Z"
              fill="white"
            />
          </g>
          <g id="Group_3">
            <path
              id="Vector_2"
              d="M13.875 17.25H7.875C5.8125 17.25 4.125 18.9375 4.125 21V29.25C4.125 30.6375 5.1 31.8 6.375 32.1375V44.25C6.375 45.4875 7.3875 46.5 8.625 46.5C9.8625 46.5 11.8875 46.5 13.125 46.5C14.3625 46.5 15.375 45.4875 15.375 44.25V32.25H17.625V21C17.625 18.9375 15.9375 17.25 13.875 17.25Z"
              fill="transparent"
            />
          </g>
          <g id="Group_4">
            <path
              id="Vector_3"
              d="M10.875 13.5C12.9461 13.5 14.625 11.8211 14.625 9.75C14.625 7.67893 12.9461 6 10.875 6C8.80393 6 7.125 7.67893 7.125 9.75C7.125 11.8211 8.80393 13.5 10.875 13.5Z"
              fill="transparent"
            />
          </g>
          <g id="Group_5">
            <path
              id="Vector_4"
              d="M40.125 17.25H34.125C32.0625 17.25 30.375 18.9375 30.375 21V29.25C30.375 30.6375 31.35 31.8 32.625 32.1375V44.1375C32.625 45.375 33.5625 46.4625 34.8 46.4625C36.075 46.5 38.175 46.5 39.45 46.4625C40.6875 46.425 41.625 45.3375 41.625 44.1375V32.25C42.8625 32.25 43.875 31.2375 43.875 30V21C43.875 18.9375 42.1875 17.25 40.125 17.25Z"
              fill="transparent"
            />
          </g>
          <g id="Group_6">
            <path
              id="Vector_5"
              d="M37.125 13.5C39.1961 13.5 40.875 11.8211 40.875 9.75C40.875 7.67893 39.1961 6 37.125 6C35.0539 6 33.375 7.67893 33.375 9.75C33.375 11.8211 35.0539 13.5 37.125 13.5Z"
              fill="transparent"
            />
          </g>
          <g id="Group_7">
            <path
              id="Vector_6"
              d="M6.375 47.625C5.7375 47.625 5.25 47.1375 5.25 46.5V32.925C3.9 32.25 3 30.825 3 29.25V21C3 18.3 5.175 16.125 7.875 16.125H13.875C14.5125 16.125 15 16.6125 15 17.25C15 17.8875 14.5125 18.375 13.875 18.375H7.875C6.4125 18.375 5.25 19.5375 5.25 21V29.25C5.25 30.1125 5.8125 30.8625 6.6375 31.05C7.125 31.1625 7.5 31.6125 7.5 32.1375V46.5C7.5 47.1375 7.0125 47.625 6.375 47.625Z"
              fill="#BDB2FF"
            />
          </g>
          <g id="Group_8">
            <path
              id="Vector_7"
              d="M10.875 14.625C8.175 14.625 6 12.45 6 9.75C6 7.05 8.175 4.875 10.875 4.875C13.575 4.875 15.75 7.05 15.75 9.75C15.75 12.45 13.575 14.625 10.875 14.625ZM10.875 7.125C9.4125 7.125 8.25 8.2875 8.25 9.75C8.25 11.2125 9.4125 12.375 10.875 12.375C12.3375 12.375 13.5 11.2125 13.5 9.75C13.5 8.2875 12.3375 7.125 10.875 7.125Z"
              fill="#BDB2FF"
            />
          </g>
          <g id="Group_9">
            <path
              id="Vector_8"
              d="M32.625 47.6242C31.9875 47.6242 31.5 47.1367 31.5 46.4992V35.8867C31.5 35.2492 31.9875 34.7617 32.625 34.7617C33.2625 34.7617 33.75 35.2492 33.75 35.8867V46.4992C33.75 47.1367 33.2625 47.6242 32.625 47.6242Z"
              fill="#BDB2FF"
            />
          </g>
          <g id="Group_10">
            <path
              id="Vector_9"
              d="M41.625 47.5125C40.9875 47.5125 40.5 47.025 40.5 46.3875V32.25C40.5 31.6125 40.9875 31.125 41.625 31.125C42.2625 31.125 42.75 30.6375 42.75 30V21C42.75 19.5375 41.5875 18.375 40.125 18.375H34.125C33.4875 18.375 33 17.8875 33 17.25C33 16.6125 33.4875 16.125 34.125 16.125H40.125C42.825 16.125 45 18.3 45 21V30C45 31.4625 44.0625 32.7 42.75 33.1875V46.425C42.75 47.025 42.2625 47.5125 41.625 47.5125Z"
              fill="#BDB2FF"
            />
          </g>
          <g id="Group_11">
            <path
              id="Vector_10"
              d="M37.125 14.625C34.425 14.625 32.25 12.45 32.25 9.75C32.25 7.05 34.425 4.875 37.125 4.875C39.825 4.875 42 7.05 42 9.75C42 12.45 39.825 14.625 37.125 14.625ZM37.125 7.125C35.6625 7.125 34.5 8.2875 34.5 9.75C34.5 11.2125 35.6625 12.375 37.125 12.375C38.5875 12.375 39.75 11.2125 39.75 9.75C39.75 8.2875 38.5875 7.125 37.125 7.125Z"
              fill="#BDB2FF"
            />
          </g>
          <g id="Group_12">
            <path
              id="Vector_11"
              d="M15.375 40.125C14.7375 40.125 14.25 39.6375 14.25 39V33.75C14.25 33.1125 14.7375 32.625 15.375 32.625C16.0125 32.625 16.5 33.1125 16.5 33.75V39C16.5 39.6375 16.0125 40.125 15.375 40.125Z"
              fill="#2B2D2E"
            />
          </g>
          <g id="Group_13">
            <path
              id="Vector_12"
              d="M24 11.25C26.0711 11.25 27.75 9.57107 27.75 7.5C27.75 5.42893 26.0711 3.75 24 3.75C21.9289 3.75 20.25 5.42893 20.25 7.5C20.25 9.57107 21.9289 11.25 24 11.25Z"
              fill="white"
            />
          </g>
          <g id="Group_14">
            <path
              id="Vector_13"
              d="M24 12.375C21.3 12.375 19.125 10.2 19.125 7.5C19.125 4.8 21.3 2.625 24 2.625C26.7 2.625 28.875 4.8 28.875 7.5C28.875 10.2 26.7 12.375 24 12.375ZM24 4.875C22.5375 4.875 21.375 6.0375 21.375 7.5C21.375 8.9625 22.5375 10.125 24 10.125C25.4625 10.125 26.625 8.9625 26.625 7.5C26.625 6.0375 25.4625 4.875 24 4.875Z"
              fill="#2B2D2E"
            />
          </g>
          <path
            id="Vector_14"
            d="M35.625 45.375H29.625V32.55V32.25V30.9375C30.9375 30.4875 31.875 29.2125 31.875 27.75V21C31.875 19.3125 31.5375 13.875 27 13.875H20.55C18.1125 13.875 16.0125 15.7125 15.7125 18.15L14.25 29.85C14.175 30.45 14.625 31.0125 15.225 31.0875C15.825 31.1625 16.3875 30.7125 16.4625 30.1125L17.925 18.4125C18.075 17.1 19.2 16.125 20.5125 16.125H27C29.2875 16.125 29.625 19.1625 29.625 21V27.75C29.625 28.3875 29.1375 28.875 28.5 28.875C27.8625 28.875 27.375 29.3625 27.375 30V32.25V32.55V45.375H25.125V32.25C25.125 31.6125 24.6375 31.125 24 31.125C23.3625 31.125 22.875 31.6125 22.875 32.25V45.375H20.625V30C20.625 29.3625 20.1375 28.875 19.5 28.875C18.8625 28.875 18.375 29.3625 18.375 30V45.375H12.375C11.7375 45.375 11.25 45.8625 11.25 46.5C11.25 47.1375 11.7375 47.625 12.375 47.625H35.625C36.2625 47.625 36.75 47.1375 36.75 46.5C36.75 45.8625 36.2625 45.375 35.625 45.375Z"
            fill="#2B2D2E"
          />
        </g>
      </g>
    </svg>
  )
}
